<template>
  <div>



    <div id="echart"> 图表区域</div>



    <div class="container">
      <div style="margin-bottom: 20px; " size="medium">
        <el-radio-group v-model="radioCycle">
          <el-radio-button label="daily"></el-radio-button>
          <el-radio-button label="weekly"></el-radio-button>
          <el-radio-button label="monthly"></el-radio-button>
        </el-radio-group>

        <el-button type="primary" @click="exportCsv"   style="margin-left: 80px;" >下载 CSV</el-button>

      </div>
    </div>


    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }">
      <el-table-column prop="date" label="日期" width="110" sortable>
      </el-table-column>
      <el-table-column prop="subs_start" label="本周期初始订阅">
      </el-table-column>
      <el-table-column prop="subs_new" label="本周期新增订阅">
      </el-table-column>

      <el-table-column prop="subs_recall" label="本周期召回订阅">
      </el-table-column>
      <el-table-column prop="subs_churn" label="本周期流失订阅">
      </el-table-column>
      <el-table-column prop="subs_balance" label="订阅者平衡">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColor(scope.row.subs_balance) }">{{ scope.row.subs_balance }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subs_end" label="本周期最终订阅">
      </el-table-column>

      <el-table-column prop="subs_new_roll" label="回滚新增订阅">
      </el-table-column>

      <el-table-column prop="subs_recall_roll" label="回滚召回订阅">
      </el-table-column>
      <el-table-column prop="subs_churn_roll" label="回滚流失订阅">
      </el-table-column>
      <el-table-column prop="subs_balance_roll" label="回滚30天净增加">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColor(scope.row.subs_balance_roll) }">{{ scope.row.subs_balance_roll
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="churn_rate" label="流失率">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColorBad(scope.row.trend) }">{{ scope.row.churn_rate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="year_over_year" label="去年同期">
        <template slot-scope="scope">
          <span :style="{ color: getBalanceColorBad(scope.row.trend) }">{{ scope.row.year_over_year }}</span>
        </template>
      </el-table-column>


    </el-table>




  </div>
</template>

<script>

import { exportToCsv } from '@/utils/exportToCsv';
export default {
  components:
    {},

  data() {
    return {
      tableData: [],
      radioCycle: 'daily',

    }
  },

  watch: {
    //watch  观察变化, 来自苏驰的优化
    $route(newVal, oldVal) {
      this.getData(newVal.params.bike_type, newVal.params.cycle)
    },
    radioCycle(newV, oldVal) {
      this.$router.replace(`/churnRate/${this.$route.params.bike_type}/${newV}`)
    }
  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods: {
    exportCsv(){
      let  fileName  =   "churnRate_"+ this.$route.params.bike_type+  "_"+ this.$route.params.cycle
      exportToCsv(this.tableData,fileName)
    },


    async getData(bike_type, cycle) {
      // const bike_type = bike_type;
      // const cycle = cycle;
      this.tableData = []

      let res = await this.$http.get("/da/churn_rate/" + bike_type + "/" + cycle)
      this.tableData = res.data
      this.getLoadEcharts();
    },


    getLoadEcharts() {
      // 调用 this.getData() 方法获取数据
      let data = this.tableData;

      if (data.length > 50) {
        data = data.slice(data.length - 50);
      }
      console.log("data  option\n", data);
      // 提取 date 和 churn_rate 数据
      const dates = data.map(item => item.date);
      const churnRates = data.map(item => parseFloat(item.churn_rate) * 1);
      const YoY = data.map(item => parseFloat(item.year_over_year) * 1);


      var chart = this.$echarts.init(
        document.getElementById("echart")
      );


      const option = {
        title: {
          text: 'Churn Rate' // 标题文本
        },
        legend: {
          data: ['Churn Rate', '去年同期'], // 系列名称
          top: 'top', // 图例位置在顶部
          selected: {
            'Churn Rates': true, // 默认显示 'Churn Rates' 系列
            '去年同期': true // 默认不显示 'YoY' 系列
          }
        },

        xAxis: {
          type: 'category',
          data: dates
        },
        yAxis: {
          type: 'value',
          name: 'Churn Rate', // 坐标轴名称
          min: 0, // 最小值
          max: 10, // 最大值
          axisLabel: {
            formatter: '{value}%' // 格式化标签显示为百分比
          }
        },


        series: [{
          name: 'Churn Rate', // 系列名称
          type: 'line',
          data: churnRates
        },
        {
          name: '去年同期', // 系列名称
          type: 'line',
          data: YoY
        },
        ],

        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (params.seriesName === 'Churn Rate') {
              // 当系列名称为'Churn Rates'时，显示所有信息
              return params.seriesName + '<br/>' + params.name + ' : ' + params.value + '%';
            } else if (params.seriesName === '去年同期') {
              // 当系列名称为'去年同期'时，不显示{b}的值
              return params.seriesName + ' : ' + params.value + '%';
            }
          }
        },

      };



      chart.setOption(option);
    },

    getBalanceColor(value) {
      if (value > 0.1) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= -0.1 && value < 0.1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },

    getBalanceColorBad(value) {

      if (value < -0.1) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >= -0.1 && value < 0.1) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    }
  },
  handleRadioChange() {
    this.$router.replace(`/churnRate/${this.$route.params.bike_type}/${this.radioCycle}`);
  },
  beforeRouteUpdate(to, from, next) {
    // 检查路由参数是否发生变化
    if (to.params.bike_type !== from.params.bike_type || to.params.cycle !== from.params.cycle) {
      // 更新 el-radio-group 的选择项
      this.radioCycle = to.params.cycle;
    }
    next();
  },



  mounted: function () {
    //注意回调函数的作用域!!!
    const bike_type = this.$route.params.bike_type;
    const cycle = this.$route.params.cycle;
    this.getData(bike_type, cycle);



    // 继续执行你的代码

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}


#echart {
  width: 80%;
  height: 400px;
  margin: auto;
  border: 1px solid #060632;
}
</style>